module.exports = __webpack_public_path__ + "static/img/首页3.3d9048b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/首页3.png
// module id = BdTU
// module chunks = 2